import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_URL } from '../config/api.config';
import { ApiResponse } from '../models/api.model';
import { ConfiguracionSistema, EstadoSistema } from '../models/configuracion-sistema.model';

@Injectable({ providedIn: 'root' })
export class ConfiguracionSistemaService {
  private readonly http = inject(HttpClient);
  private readonly resourceUrl = `${API_URL}/configuracion-sistema`;

  get(): Observable<ApiResponse<ConfiguracionSistema>> {
    return this.http.get<ApiResponse<ConfiguracionSistema>>(this.resourceUrl);
  }

  update(
    configuracion: Omit<ConfiguracionSistema, 'fechaActualizacion'>,
  ): Observable<ApiResponse<ConfiguracionSistema>> {
    return this.http.put<ApiResponse<ConfiguracionSistema>>(this.resourceUrl, configuracion);
  }

  getStatus(): Observable<ApiResponse<EstadoSistema>> {
    return this.http.get<ApiResponse<EstadoSistema>>(`${this.resourceUrl}/estado`);
  }
}
